// English catalogue. Keys are flat strings (i18next keySeparator is off).
// Every key here must exist in ml.ts: the Catalogue type makes a missing key a compile error.
export const en = {
  'app.name': 'Rabita One',
  'app.devBanner': 'Development build: sample data; sign-in codes are printed in the API console.',

  'nav.overview': 'Overview',
  'nav.dashboard': 'Dashboard',
  'nav.community': 'Community',
  'nav.register': 'Member Register',
  'nav.register.members': 'Member Management',
  'nav.register.lifeEvents': 'Life Events',
  'nav.register.pravasi': 'Pravasi Register',
  'nav.register.wards': 'Wards & Areas',
  'nav.register.transfers': 'Transfers Out',
  'nav.register.documents': 'Member Documents',
  'nav.register.idCards': 'Member ID Cards',
  'nav.register.selfRegistration': 'Self Registration',
  'nav.varisankhya': 'Varisankhya',
  'nav.varisankhya.dues': 'Dues & Arrears',
  'nav.varisankhya.collect': 'Collect Payment',
  'nav.varisankhya.receipts': 'Receipts',
  'nav.varisankhya.plans': 'Rate Plans',
  'nav.certificates': 'Certificates',
  'nav.certificates.requests': 'Requests',
  'nav.certificates.issued': 'Issued Register',
  'nav.madrasa': 'Madrasa',
  'nav.madrasa.students': 'Students',
  'nav.madrasa.attendance': 'Attendance',
  'nav.engage': 'Engage',
  'nav.communication': 'Communication',
  'nav.communication.announcements': 'Announcements',
  'nav.communication.send': 'Send Message',
  'nav.notifications': 'Notifications',
  'nav.approvals': 'Approvals',
  'nav.administration': 'Administration',
  'nav.accounts': 'Accounts & Waqf',
  'nav.committee': 'Committee',
  'nav.settings': 'Settings',
  'form.save': 'Save',
  'form.cancel': 'Cancel',
  'form.saving': 'Saving…',
  'form.choose': 'Choose…',
  'form.phoneHint': 'Indian mobiles can be typed without +91. Numbers abroad need the country code.',
  'house.add': 'Add house',
  'house.edit': 'Edit house',
  'house.section': 'House',
  'house.headSection': 'Head of the family',
  'house.numberPreview': 'This house will be number {{no}}.',
  'house.consentNote': "Consent starts as pending. Record the family's consent when they sign it (slice 5).",
  'house.statusHint': 'A house is never deleted. When a family leaves, set it to Moved out.',
  'field.personEn': 'Name (English)',
  'field.personMl': 'Name (Malayalam)',
  'field.gender': 'Gender',
  'gender.M': 'Male',
  'gender.F': 'Female',
  'field.birthYear': 'Year of birth',
  'field.countryOnly': 'Country',
  'field.stateOnly': 'State',
  'field.regionAbroad': 'Emirate / province',
  'field.monthlyRate': 'Monthly amount (₹)',
  'field.status': 'Status',
  'member.add': 'Add member',
  'member.edit': 'Edit member',
  'member.section': 'Member',
  'member.statusHint': 'People are never deleted. Change the status when someone dies, marries out or moves away.',
  'mstatus.ALIVE': 'Living',
  'mstatus.DECEASED': 'Deceased',
  'mstatus.MARRIED_OUT': 'Married out',
  'mstatus.TRANSFERRED': 'Transferred',
  'wards.title': 'Wards & Areas',
  'wards.desc': 'The areas inside the mahallu. Each ward numbers its own houses.',
  'wards.add': 'Add ward',
  'wards.rename': 'Rename ward',
  'wards.section': 'Ward',
  'wards.code': 'Code',
  'wards.nameEn': 'Name (English)',
  'wards.nameMl': 'Name (Malayalam)',
  'wards.codeHint': 'Short and permanent, e.g. W5. It appears in house numbers.',
  'wards.codeFixed': 'The code is part of house numbers and cannot change.',
  'wards.nextHouse': 'Next house number',
  'nav.settings.sequences': 'Numbering',
  'seq.title': 'Numbering',
  'seq.desc': 'Every number Rabita One issues comes from here: house numbers, receipts and certificates. A number is never issued twice.',
  'seq.pattern': 'Pattern',
  'seq.tokens': 'Tokens: {YYYY} year · {YY} short year · {MM} month · {WARD} ward · {SEQ4} running number with 4 digits (3 to 8).',
  'seq.reset': 'Starts again at 1',
  'seq.reset.NEVER': 'Never',
  'seq.reset.YEARLY': 'Every year (1 January)',
  'seq.reset.MONTHLY': 'Every month',
  'seq.scope.WARD': 'Numbered separately in each ward',
  'seq.preview': 'Next number will look like',
  'seq.next': 'Next number',
  'seq.save': 'Save pattern',
  'seq.saved': 'Saved.',
  'seq.resetHint': 'The restart rule can change only before the first number is issued.',
  'seq.raise': 'Continue from',
  'seq.raiseHint': 'To continue from a paper book, set the next number here. It can only be raised, never lowered.',
  'seq.set': 'Set',
  'seq.ward': 'Ward',
  'seq.readOnly': 'Only the secretary or a mahallu admin can change numbering.',

  'header.search': 'Search houses, members, receipts',
  'header.notifications': 'Notifications',
  'header.language': 'Language',

  'dash.greeting': 'Assalamu alaikum',
  'dash.subtitle': 'Here is your mahallu today.',
  'dash.houses': 'Houses',
  'dash.members': 'Members',
  'dash.pravasiHouses': 'Houses with pravasi',
  'dash.arrearsHouses': 'Houses 3+ months behind',
  'dash.openRegister': 'Open the member register',

  'mm.title': 'Member Management',
  'mm.desc': 'Every house in the mahallu: its family, where each member lives, its varisankhya plan and its records.',
  'mm.exportAll': 'Export all',
  'mm.currentView': 'Current view',
  'mm.import': 'Import',
  'mm.wards': 'Wards',
  'mm.ratePlans': 'Rate plans',
  'mm.dataHealth': 'Data health',
  'mm.addHouse': 'Add house',
  'mm.notYet': 'This action arrives in a later step.',

  'f.ward': 'Ward',
  'f.allWards': 'All wards',
  'f.status': 'Status',
  'f.allStatus': 'All status',
  'f.residence': 'Residence',
  'f.anyResidence': 'Any residence',
  'f.hasPravasi': 'Has pravasi',
  'f.hasOtherState': 'Has other-state members',
  'f.allResident': 'All resident',
  'f.count': '{{count}} houses',
  'f.count_one': '{{count}} house',

  'tile.all': 'Total houses',
  'tile.members': 'Members',
  'tile.pravasi': 'Houses with pravasi',
  'tile.other': 'Houses with other-state members',
  'tile.phone': 'Phone not verified',
  'tile.consent': 'Consent pending',
  'tile.arrears': 'Arrears 3+ months',
  'tile.fix': 'Fix',

  'col.house': 'House',
  'col.head': 'Head of house',
  'col.ward': 'Ward',
  'col.members': 'Members',
  'col.plan': 'Plan',
  'col.arrears': 'Arrears',
  'col.phone': 'Phone',
  'col.status': 'Status',
  'col.actions': 'Actions',

  'table.search': 'Search by house name, number or head…',
  'table.columns': 'Columns',
  'table.perPage': '{{n}} per page',
  'table.showing': 'Showing {{from}}–{{to}} of {{total}}',
  'table.empty': 'Nothing matches this filter. Clear the search or pick another tile.',
  'table.loading': 'Loading the register…',
  'table.error': 'The register could not load. Check that the API is running, then try again.',
  'table.signedOut': 'Your sign-in has ended. Please sign in again.',
  'table.forbidden': 'You do not have access to this.',
  'table.retry': 'Try again',
  'table.view': 'View house',

  'badge.verified': 'Verified',
  'badge.notVerified': 'Not verified',
  'badge.abroad': '{{n}} abroad',
  'badge.otherState': '{{n}} other state',

  'status.ACTIVE': 'Active',
  'status.MOVED_OUT': 'Moved out',
  'plan.STANDARD': 'Standard',
  'plan.NRI': 'NRI',
  'plan.EXEMPT': 'Exempt',
  'consent.GIVEN': 'Given',
  'consent.PENDING': 'Pending',
  'unit.perMonth': '/month',
  'unit.months': '{{n}} mo',

  'tab.overview': 'Overview',
  'tab.members': 'Members',
  'tab.residence': 'Residence',
  'tab.varisankhya': 'Varisankhya',
  'tab.certificates': 'Certificates',
  'tab.madrasa': 'Madrasa',
  'tab.documents': 'Documents',
  'tab.notes': 'Notes',
  'tab.history': 'History',
  'drawer.close': 'Close',
  'drawer.memberCount': '{{n}} members',
  'drawer.arrearsNote': 'Arrears are shown for information only. They never block a certificate, a burial record or madrasa admission. The committee decides.',
  'drawer.comingLater': 'This tab fills in when its module is built.',
  'drawer.allResident': 'Everyone in this house lives in the mahallu.',
  'drawer.loading': 'Loading the house…',

  'field.houseNo': 'House number',
  'field.ward': 'Ward',
  'field.nameEn': 'House name (English)',
  'field.nameMl': 'House name (Malayalam)',
  'field.head': 'Head of house',
  'field.ownership': 'Ownership',
  'field.plan': 'Varisankhya plan',
  'field.consent': 'Consent to data use',
  'field.name': 'Name',
  'field.relation': 'Relation',
  'field.born': 'Born',
  'field.lives': 'Lives',
  'field.phone': 'Phone',
  'field.country': 'Country / state',
  'field.city': 'City',
  'field.work': 'Work',

  'ownership.OWN': 'Own house',
  'ownership.RENTED': 'Rented',
  'rel.HEAD': 'Head',
  'rel.WIFE': 'Wife',
  'rel.HUSBAND': 'Husband',
  'rel.SON': 'Son',
  'rel.DAUGHTER': 'Daughter',
  'rel.FATHER': 'Father',
  'rel.MOTHER': 'Mother',
  'rel.OTHER': 'Other',
  'res.RESIDENT': 'Resident',
  'res.OTHER_STATE': 'Other state',
  'res.ABROAD': 'Abroad',

  'signin.steps': 'Sign-in steps',
  'signin.stepNumber': 'Your number',
  'signin.stepCode': 'Code',
  'signin.stepVerify': 'Authenticator',
  'signin.sending': 'Sending…',
  'signin.title': 'Sign in to your mahallu',
  'signin.subtitle': 'We send a one-time code to your phone or email.',
  'signin.identifier': 'Mobile number or email',
  'signin.identifierHint': 'Indian mobiles can be typed without +91. Numbers abroad need the country code.',
  'signin.channel': 'Send the code by',
  'channel.WHATSAPP': 'WhatsApp',
  'channel.SMS': 'SMS',
  'channel.EMAIL': 'Email',
  'signin.sendCode': 'Send code',
  'signin.codeTitle': 'Enter the code',
  'signin.codeSent': 'We sent a 6-digit code by {{channel}} to {{destination}}.',
  'signin.code': '6-digit code',
  'signin.continue': 'Continue',
  'signin.resend': 'Send a new code',
  'signin.resendIn': 'You can ask for a new code in {{n}} s.',
  'signin.trySms': 'Send by SMS instead',
  'signin.change': 'Use a different number or email',
  'signin.devHint': 'Development build: the code is printed in the API console, not sent (or 000000 when DEV_FIXED_OTP is set).',
  'signin.codeWrong': 'That code is not right. {{n}} tries left.',
  'signin.codeExpired': 'This code has expired or was used up. Ask for a new one.',
  'signin.tooMany': 'Too many attempts. Please wait a little and try again.',
  'signin.error': 'Something went wrong. Please try again.',
  'signin.chooseTitle': 'Choose a mahallu',
  'signin.chooseBody': 'You belong to more than one mahallu. Pick the one to open.',
  'mfa.title': 'Two-step sign-in',
  'mfa.setupBody': 'Committee accounts need an authenticator app, such as Google Authenticator or Microsoft Authenticator. Scan this code with the app, then enter the 6-digit code it shows.',
  'mfa.manualKey': 'Or type this key into the app:',
  'mfa.enterBody': 'Enter the 6-digit code from your authenticator app.',
  'mfa.code': 'Authenticator code',
  'mfa.verify': 'Verify',
  'mfa.loading': 'Preparing your authenticator code…',
  'member.title': 'Members use the Rabita One app',
  'member.body': 'This screen is for the mahallu committee. The member app for families comes next.',
  'header.signOut': 'Sign out',
  'role.MAHALLU_ADMIN': 'Mahallu admin',
  'role.PRESIDENT': 'President',
  'role.SECRETARY': 'Secretary',
  'role.TREASURER': 'Treasurer',
  'role.COLLECTOR': 'Collector',
  'role.WARD_REP': 'Ward representative',
  'role.SADR': 'Sadr usthad',
  'role.USTHAD': 'Usthad',
  'role.MEMBER': 'Member',

  'nav.settings.users': 'Users & roles',
  'header.account': 'Account',
  'header.actAs': 'Act as',
  'header.sessions': 'Active sessions',
  'users.title': 'Users & roles',
  'users.desc': 'Who can sign in to this mahallu, and as what. Ward representatives and collectors see only their ward.',
  'users.invite': 'Give access',
  'users.person': 'Person',
  'users.roles': 'Roles',
  'users.twoStep': 'Authenticator',
  'users.twoStepOn': 'Set up',
  'users.twoStepOff': 'Not set up',
  'users.lastSeen': 'Last active',
  'users.status': 'Access',
  'users.ACTIVE': 'Active',
  'users.REVOKED': 'Removed',
  'users.you': 'You',
  'users.never': 'Never',
  'users.manage': 'Manage access',
  'users.loading': 'Loading people…',
  'users.section': 'Person',
  'users.identifier': 'Mobile number or email',
  'users.identifierHint': 'They sign in with a one-time code sent here. Indian mobiles can be typed without +91.',
  'users.name': 'Name',
  'users.role': 'Role',
  'users.ward': 'Ward',
  'users.wardHint': 'A ward representative or collector sees only this ward.',
  'users.rolesSection': 'Roles held',
  'users.addRole': 'Add role',
  'users.removeRole': 'Remove role',
  'users.mfaSection': 'Authenticator app',
  'users.resetMfa': 'Reset authenticator',
  'users.resetMfaHint': 'For a lost or changed phone. They set up a new one at their next sign-in.',
  'users.accessSection': 'Access',
  'users.revoke': 'Remove access',
  'users.revokeHint': 'Ends every sign-in they have in this mahallu at once.',
  'users.restore': 'Give access back',
  'users.restoreHint': 'Their access was removed. Giving it back restores the roles listed above.',
  'users.confirm': 'Are you sure?',
  'users.yes': 'Yes',
  'users.no': 'No',
  'users.done': 'Done',
  'sessions.title': 'Active sessions',
  'sessions.desc': 'Every device where you are signed in. End any you do not recognise.',
  'sessions.endOthers': 'Sign out everywhere else',
  'sessions.device': 'Device',
  'sessions.mahallu': 'Mahallu',
  'sessions.role': 'Role',
  'sessions.started': 'Signed in',
  'sessions.lastSeen': 'Last active',
  'sessions.thisDevice': 'This device',
  'sessions.end': 'End',
  'sessions.ended': '{{n}} other sign-ins ended.',
  'sessions.loading': 'Loading sessions…',

  'member.continueAs': 'Continue as {{role}}',

  // Profile, brand, settings, audit log (pilot slice 11)
  'app.descriptor': 'Mahallu Cloud by OptiFi',
  'app.tagline': 'Every mahallu, connected.',
  'nav.settings.profile': 'Mahallu profile',
  'nav.settings.app': 'App settings',
  'nav.settings.audit': 'Audit log',
  'print.waqf': 'Waqf Board Reg. No.',
  'profile.title': 'Mahallu profile',
  'profile.desc': 'Your mahallu’s name, address, registrations, colour and mark. They appear on receipts, certificates and your public pages.',
  'profile.identity': 'Name and address',
  'profile.nameEn': 'Name (English)',
  'profile.nameMl': 'Name (Malayalam)',
  'profile.addressEn': 'Address (English)',
  'profile.addressMl': 'Address (Malayalam)',
  'profile.district': 'District',
  'profile.pin': 'PIN code',
  'profile.phone': 'Office phone',
  'profile.email': 'Office email',
  'profile.registrations': 'Registrations',
  'profile.waqf': 'Waqf Board registration number',
  'profile.waqfHint': 'Printed on receipts and certificates.',
  'profile.reg12a': '12A registration',
  'profile.reg80g': '80G registration',
  'profile.taxHint': 'Printed on donation receipts when given.',
  'profile.colour': 'Your colour',
  'profile.colourHex': 'Colour code (e.g. #1F7A6D)',
  'profile.colourHint': 'Used on your mark’s badge. It must be dark enough to read on white (4.5 : 1).',
  'profile.preview': 'Contrast on white',
  'profile.mark': 'Mahallu mark',
  'profile.markHint': 'A PNG or JPEG of up to {{kb}} KB, shown in the side panel and printed on receipts and certificates.',
  'profile.noMark': 'No mark yet.',
  'profile.markFile': 'Image',
  'profile.upload': 'Upload',
  'profile.remove': 'Remove',
  'appset.title': 'App settings',
  'appset.desc': 'How Rabita One behaves for your mahallu: the language of messages to families, and which messages are sent.',
  'appset.messages': 'Messages to families',
  'appset.lang': 'Message language',
  'appset.langHint': 'Receipts, announcements and janaza alerts go in this language.',
  'appset.notifyDefault': '“Send the receipt to the family” starts ticked',
  'appset.on': 'Send',
  'appset.sms': 'SMS if WhatsApp fails',
  'appset.locked': 'Always on',
  'appset.whatsappOnly': 'WhatsApp only',
  'appset.lockedHint': 'Sign-in codes and janaza alerts are safety messages: they cannot be switched off.',
  'auditlog.title': 'Audit log',
  'auditlog.desc': 'Every change in your mahallu, who made it and when. Nobody can edit or delete it, including OptiFi.',
  'auditlog.action': 'Action',
  'auditlog.all': 'All actions',
  'auditlog.search': 'Search the details',
  'auditlog.who': 'Who',
  'auditlog.what': 'About',
  'auditlog.count': '{{n}} entries',
  'notice.skip.SWITCHED_OFF': 'No message: receipt messages are switched off in App settings.',

  // Announcements, notifications, approvals (pilot slice 10)
  'ann.title': 'Announcements',
  'ann.desc': 'Notices to the mahallu on WhatsApp. Another committee member approves each one before it goes. Only houses that agreed to receive notices get them. A janaza alert goes at once.',
  'ann.new': 'New announcement',
  'ann.sendTitle': 'Message one house',
  'ann.submit': 'Send for approval',
  'ann.howItGoes': 'Goes on WhatsApp after another committee member approves it, to houses that agreed to receive notices. Write it in Malayalam too, so families get it in Malayalam.',
  'ann.message': 'Message',
  'ann.titleEn': 'Title (English)',
  'ann.titleMl': 'Title (Malayalam)',
  'ann.bodyEn': 'Text (English)',
  'ann.bodyMl': 'Text (Malayalam)',
  'ann.to': 'To',
  'ann.audience': 'Send to',
  'ann.approve': 'Approve and send',
  'ann.by': 'By {{name}}, {{when}}',
  'ann.approvedBy': 'approved by {{name}}',
  'ann.reached': 'Sent to {{n}} houses',
  'ann.skippedConsent': '{{n}} houses have not agreed to receive notices',
  'ann.skippedPhone': '{{n}} houses have no mobile number',
  'ann.none': 'No announcements yet.',
  'audience.ALL': 'The whole mahallu',
  'audience.WARDS': 'Some wards',
  'audience.PRAVASI': 'Houses with members abroad',
  'audience.HOUSE': 'One house',
  'astate.PENDING': 'Waiting for approval',
  'astate.SENT': 'Sent',
  'astate.REJECTED': 'Not sent',
  'janaza.title': 'Janaza alert',
  'janaza.badge': 'Janaza',
  'janaza.send': 'Send now',
  'janaza.hint': 'Goes at once, without approval, on WhatsApp and then SMS, to every house in the register that gave consent. Families cannot mute it. Record the death in the register first.',
  'janaza.person': 'Who passed away',
  'janaza.details': 'Janaza',
  'janaza.prayerAt': 'Janaza prayer time',
  'janaza.prayerPlace': 'Janaza prayer place',
  'notif.title': 'Notifications',
  'notif.desc': 'What happened that needs your attention.',
  'notif.markAll': 'Mark all read',
  'notif.new': 'New',
  'notif.none': 'No notifications.',
  'notif.unread': '{{n}} unread notifications',
  'notif.CERT_TO_SIGN': 'A certificate for {{name}} is waiting for your signature',
  'notif.ANNOUNCEMENT_TO_APPROVE': 'Announcement “{{title}}” is waiting for approval',
  'notif.PRIVACY_REQUEST': 'Privacy request {{requestNo}} has arrived',
  'notif.JANAZA_SENT': 'Janaza alert sent for {{name}}',
  'inbox.title': 'Approvals',
  'inbox.desc': 'Everything waiting for you in your current role: signatures, approvals and requests to answer.',
  'inbox.none': 'Nothing is waiting for you.',
  'inbox.CERT_SIGNATURE': 'Sign the certificate for {{label}}',
  'inbox.ANNOUNCEMENT_APPROVAL': 'Approve the announcement “{{label}}”',
  'inbox.PRIVACY_REQUEST': 'Answer privacy request {{label}}',
  'inbox.FAILED_MESSAGES': '{{label}} messages could not be delivered',
  'template.ANNOUNCEMENT': 'Announcement',
  'template.JANAZA_ALERT': 'Janaza alert',

  // Certificates (pilot slice 9)
  'cert.requestsTitle': 'Certificate requests',
  'cert.requestsDesc': 'Record a request, then two different signatories sign it. The second signature issues the certificate with its number; the PDF is printed a few seconds later.',
  'cert.new': 'New request',
  'cert.record': 'Record request',
  'cert.section': 'Who and what',
  'cert.type': 'Certificate',
  'cert.deceasedHint': 'Only members recorded as deceased are listed. Record the death in the register first.',
  'cert.purpose': 'Issued for',
  'cert.purposeHint': 'For example: passport, school admission, bank account.',
  'cert.spouse': 'Spouse',
  'cert.spouseName': 'Spouse’s name',
  'cert.spouseMahallu': 'Spouse’s mahallu',
  'cert.nikahDate': 'Nikah date',
  'cert.nikahNote': 'The certificate says it does not replace marriage registration with the local body.',
  'cert.dateOfDeath': 'Date of death',
  'cert.placeOfDeath': 'Place of death',
  'cert.burialDate': 'Burial date',
  'cert.burialPlace': 'Place of burial',
  'cert.died': 'Died',
  'cert.buried': 'Buried',
  'cert.note': 'Note',
  'cert.signatures': '{{n}} of 2 signatures',
  'cert.sign': 'Sign',
  'cert.details': 'Details',
  'cert.requestedBy': 'Requested by',
  'cert.arrearsInfo': 'Information only; never a reason to refuse.',
  'cert.rejectHint': 'The request closes with this reason. Record a new request to start again.',
  'cert.none': 'Nothing here.',
  'cert.issuedTitle': 'Issued certificates',
  'cert.issuedDesc': 'Every certificate the mahallu issued. A certificate is never changed or deleted; a wrong one is withdrawn with a reason, and its QR page then says so.',
  'cert.serial': 'Number',
  'cert.issued': 'Issued',
  'cert.withdraw': 'Withdraw',
  'cert.withdrawHint': 'The certificate stays in the register marked withdrawn. Anyone scanning its QR code sees that it was withdrawn.',
  'ctype.MEMBERSHIP': 'Membership certificate',
  'ctype.NIKAH_NOC': 'Nikah no-objection certificate',
  'ctype.DEATH_BURIAL': 'Death and burial record',
  'creq.REQUESTED': 'Waiting for signatures',
  'creq.ISSUED': 'Issued',
  'creq.REJECTED': 'Rejected',
  'cstate.ISSUED': 'Valid',
  'cstate.WITHDRAWN': 'Withdrawn',
  'pdfstate.PENDING': 'Printing',
  'pdfstate.READY': 'Ready',
  'pdfstate.FAILED': 'Failed',
  'verify.title': 'Certificate check',
  'verify.notFound': 'No certificate matches this code. Check that the whole QR code was scanned.',
  'verify.genuine': 'This certificate was issued by the mahallu below and is valid.',
  'verify.withdrawn': 'This certificate was issued by the mahallu below but was withdrawn on {{date}}. It is no longer valid.',
  'verify.mahallu': 'Mahallu',
  'verify.hint': 'Compare the number and name with the paper. The SHA-256 matches the PDF file the mahallu issued.',

  // Messages (pilot slice 8)
  'nav.communication.delivery': 'Delivery log',
  'delivery.title': 'Delivery log',
  'delivery.desc': 'Every message Rabita One sent to families: WhatsApp first, SMS if WhatsApp cannot deliver. Sign-in codes are not listed; they are never stored.',
  'delivery.all': 'All',
  'delivery.when': 'When',
  'delivery.what': 'Message',
  'delivery.to': 'To',
  'delivery.channel': 'Channel',
  'delivery.lang': 'Language',
  'delivery.steps': '{{n}} steps',
  'delivery.hide': 'Hide steps',
  'delivery.retry': 'Send again',
  'delivery.none': 'No messages here.',
  'delivery.templates': 'Message templates',
  'delivery.templatesHint': 'OptiFi registers these with WhatsApp (Meta) and the DLT SMS registry. A channel is used only once its template is approved; until then messages wait or go by the other channel.',
  'delivery.wording': 'Wording',
  'template.SIGN_IN_CODE': 'Sign-in code',
  'template.RECEIPT_ISSUED': 'Receipt',
  'channel.pending': 'Not yet sent',
  'mstatus2.QUEUED': 'Waiting',
  'mstatus2.SENDING': 'Sending',
  'mstatus2.SENT': 'Sent',
  'mstatus2.DELIVERED': 'Delivered',
  'mstatus2.READ': 'Read',
  'mstatus2.FAILED': 'Failed',
  'mevent.QUEUED': 'Queued',
  'mevent.ATTEMPT': 'Sending',
  'mevent.SENT': 'Sent',
  'mevent.DELIVERED': 'Delivered',
  'mevent.READ': 'Read',
  'mevent.RETRY': 'Will try again',
  'mevent.FALLBACK': 'Moved to the next channel',
  'mevent.FAILED': 'Failed',
  'mevent.REQUEUED': 'Queued again',
  'tstatus.DRAFT': 'Draft',
  'tstatus.SUBMITTED': 'Submitted',
  'tstatus.APPROVED': 'Approved',
  'tstatus.REJECTED': 'Rejected',
  'tstatus.PAUSED': 'Paused',
  'collect.notify': 'Send the receipt to the family on WhatsApp (SMS if WhatsApp fails)',
  'notice.queued': 'The receipt will be sent to {{to}}.',
  'notice.short': '{{channel}}: {{status}}',
  'notice.skip.NOT_REQUESTED': 'No message was sent.',
  'notice.skip.NO_HOUSE': 'No message: the donor is not in the register.',
  'notice.skip.NO_PHONE': 'No message: nobody in the house has a mobile number.',
  'notice.skip.NO_CONSENT': 'No message: the house has not given consent for varisankhya.',

  // Varisankhya (pilot slice 7)
  'collect.title': 'Collect',
  'collect.pageTitle': 'Collect payment',
  'collect.pageDesc': 'Find the house and issue a numbered receipt. Donations from someone outside the register need only their name.',
  'collect.donation': 'Donation without a house',
  'collect.donationTitle': 'Donation',
  'collect.find': 'Find a house',
  'collect.section': 'Payment',
  'collect.fund': 'Fund',
  'collect.amount': 'Amount (₹)',
  'collect.amountHint': 'Pays the oldest unpaid months first.',
  'collect.ahead': 'Months ahead',
  'collect.aheadHint': 'Also pay this many months in advance.',
  'collect.method': 'Paid by',
  'collect.reference': 'Reference',
  'collect.receivedOn': 'Received on',
  'collect.note': 'Note',
  'collect.payer': 'Donor’s name',
  'collect.issue': 'Issue receipt',
  'collect.issuedTitle': 'Receipt issued',
  'collect.issued': 'Receipt {{no}} for {{amount}} is issued.',
  'collect.forMonths': 'For: {{months}}',
  'collect.print': 'Print receipt',
  'collect.outstanding': 'Outstanding {{amount}} ({{months}} months).',
  'collect.nothingDue': 'Nothing is due now.',
  'collect.monthly': '{{amount}} a month',
  'method.CASH': 'Cash',
  'method.UPI': 'UPI',
  'method.BANK_TRANSFER': 'Bank transfer',
  'method.CHEQUE': 'Cheque',
  'account.monthly': 'Monthly amount',
  'account.arrears': 'Arrears',
  'account.outstanding': 'Outstanding now',
  'account.dues': 'Months',
  'account.noDues': 'No dues raised for this house yet.',
  'account.receipts': 'Receipts',
  'account.noReceipts': 'No receipts yet.',
  'dues.title': 'Dues & Arrears',
  'dues.desc': 'Each month the committee raises that month’s varisankhya for every house. Arrears are information only; they never block a service.',
  'dues.month': 'Month',
  'dues.arrearsList': 'Houses 3+ months behind',
  'dues.raisedHouses': 'Houses with this month’s due',
  'dues.due': 'Due for {{month}}',
  'dues.paid': 'Paid',
  'dues.unpaid': 'Not yet paid',
  'dues.raiseTitle': 'Raise dues for {{month}}',
  'dues.raiseHint': '{{n}} active houses do not have this month’s due yet. Raising is safe to repeat; a house never gets the same month twice.',
  'dues.allRaised': 'Every active house already has this month’s due.',
  'dues.raise': 'Raise dues',
  'dues.raised': 'Raised for {{n}} houses, {{amount}} in all.',
  'rcpt.title': 'Receipts',
  'rcpt.desc': 'Every receipt issued. Receipts are never deleted: a mistake is cancelled with a reason and stays in the list.',
  'rcpt.allFunds': 'All funds',
  'rcpt.status': 'Status',
  'rcpt.allStatus': 'Issued and cancelled',
  'rcpt.ISSUED': 'Issued',
  'rcpt.CANCELLED': 'Cancelled',
  'rcpt.from': 'From',
  'rcpt.to': 'To',
  'rcpt.search': 'Receipt, house or name',
  'rcpt.totals': '{{n}} receipts; issued ones total {{amount}}.',
  'rcpt.no': 'Receipt no.',
  'rcpt.date': 'Date',
  'rcpt.payer': 'Received from',
  'rcpt.by': 'Collected by',
  'rcpt.cancel': 'Cancel receipt',
  'rcpt.cancelHint': 'The receipt stays in the register marked cancelled, and the {{amount}} no longer counts. Months it paid become unpaid again.',
  'rcpt.reason': 'Reason',
  'rcpt.none': 'No receipts match.',
  'rcpt.prev': 'Previous',
  'rcpt.next': 'Next',
  'rcpt.page': 'Page {{page}} of {{pages}}',
  'plans.title': 'Rate plans & funds',
  'plans.desc': 'The monthly varisankhya for each plan, and the funds the mahallu collects for.',
  'plans.plans': 'Plans',
  'plans.hint': 'A house pays its own monthly amount, which starts from its plan. Changing a plan can also move the houses still paying the old amount; dues already raised do not change.',
  'plans.houses': 'Active houses',
  'plans.monthly': 'Monthly (₹)',
  'plans.apply': 'Also for houses on the old amount',
  'funds.title': 'Funds',
  'funds.hint': 'Varisankhya is the dues fund. Other funds take donations; a closed fund takes no new money.',
  'funds.add': 'Add fund',
  'funds.section': 'Fund',
  'funds.code': 'Code',
  'funds.codeHint': 'Capital letters, e.g. RAMADAN. It cannot change later.',
  'funds.open': 'Open',
  'funds.closed': 'Closed',
  'funds.dues': 'monthly dues',
  'funds.close': 'Close',
  'funds.reopen': 'Reopen',
  'print.receipt': 'Receipt',
  'print.months': 'Months paid',
  'print.footer': 'Thank you. Keep this receipt; its number confirms the payment.',

  // Register spreadsheet and data health (pilot slice 6)
  'mm.preparing': 'Preparing the spreadsheet…',
  'nav.register.dataHealth': 'Data health',
  'import.title': 'Import from Excel',
  'import.step1': 'Download the template. It lists the columns, how to fill each one, and your ward codes.',
  'import.template': 'Template',
  'import.step2': 'Fill one row per member. Rows with the same house key become one house, with exactly one HEAD.',
  'import.step3': 'Check the file. Nothing is saved until every row is correct; then the whole file is imported at once.',
  'import.section': 'Your file',
  'import.file': 'Excel file (.xlsx)',
  'import.fileHint': 'Up to {{mb}} MB and {{rows}} rows. Imported houses start with consent pending.',
  'import.check': 'Check file',
  'import.apply': 'Import {{houses}} houses, {{members}} members',
  'import.working': 'Reading the file…',
  'import.problems': '{{n}} problems to fix before anything is imported.',
  'import.moreProblems': '{{n}} more not shown. Fix these and check again.',
  'import.row': 'Row',
  'import.column': 'Column',
  'import.problem': 'Problem',
  'import.ready': 'The file is correct: {{houses}} houses and {{members}} members are ready to import.',
  'import.done': 'Imported {{houses}} houses and {{members}} members.',
  'import.maybeDuplicates': '{{n}} may already be in the register',
  'import.duplicateLine': 'Row {{row}} (house key {{key}}) looks like house {{houseNo}}: same ward, house name and head.',
  'health.title': 'Data health',
  'health.desc': 'Records that break a register rule, and records worth a second look. Open a house to correct it.',
  'health.loading': 'Checking the register…',
  'health.toFix': '{{n}} records need fixing.',
  'health.allClear': 'No record breaks a register rule. The checks below are worth a look.',
  'health.levelFix': 'Fix',
  'health.levelReview': 'Review',
  'health.more': '{{n}} more; the first {{limit}} are listed.',
  'health.NO_HEAD': 'Houses without a head',
  'health.NO_HEAD.why': 'Every active house needs one living head of house.',
  'health.YOUNG_HEAD': 'Head under 18',
  'health.YOUNG_HEAD.why': 'Consent is given by an adult; check the year of birth or the head.',
  'health.NO_PHONE': 'Houses with no mobile number',
  'health.NO_PHONE.why': 'Nobody in the house can receive receipts or notices.',
  'health.AWAY_NO_PLACE': 'Living away with no country or state',
  'health.AWAY_NO_PLACE.why': 'The pravasi register needs to know where each member lives.',
  'health.DUPLICATE_MEMBER': 'Same person twice in a house',
  'health.DUPLICATE_MEMBER.why': 'Same name and year of birth in one house. Mark the extra entry with the right status.',
  'health.DUPLICATE_HOUSE': 'Possible duplicate houses',
  'health.DUPLICATE_HOUSE.why': 'Same ward, house name and head. Often the same family entered twice.',
  'health.NO_BIRTH_YEAR': 'Members without a year of birth',
  'health.NO_BIRTH_YEAR.why': 'Needed for madrasa, certificates and to know who can give consent.',

  // Privacy (pilot slice 5)
  'tab.consent': 'Consent',
  'consent.WITHDRAWN': 'Withdrawn',
  'consent.NONE': 'Not recorded',
  'purpose.REGISTER': 'Register',
  'purpose.VARISANKHYA': 'Varisankhya',
  'purpose.CERTIFICATES': 'Certificates',
  'purpose.MADRASA': 'Madrasa',
  'purpose.NOTICES': 'Notices and reminders',
  'purpose.WELFARE': 'Welfare',
  'cmethod.PAPER_FORM': 'Signed paper form',
  'cmethod.IN_PERSON': 'In person',
  'cmethod.PHONE_CALL': 'Phone call',
  'cmethod.IMPORTED': 'From the old register',
  'consent.noNotice': 'No privacy notice is published yet. Publish it in Settings › Privacy before recording consent.',
  'consent.give': 'Record consent',
  'consent.withdraw': 'Record withdrawal',
  'consent.section': 'Consent',
  'consent.purposes': 'Purposes',
  'consent.purpose': 'Purpose',
  'consent.person': 'Family member',
  'consent.personHint': 'An adult member of the house, normally the head.',
  'consent.method': 'How it was given',
  'consent.note': 'Note',
  'consent.state': 'Status',
  'consent.notice': 'Notice',
  'consent.noticeV': 'Version {{n}}',
  'consent.when': 'Recorded',
  'consent.history': 'History',
  'consent.giveHint': 'Recorded against privacy notice version {{n}}. Show or read the notice to the family first.',
  'consent.olderNotice': 'Given to an older notice',
  'consent.pickPurpose': 'Choose at least one purpose.',
  'member.erasure': 'Erasure request',
  'member.erased': 'Contact details erased',
  'nav.settings.privacy': 'Privacy',
  'nav.register.privacyRequests': 'Privacy requests',
  'privacy.title': 'Privacy',
  'privacy.desc': 'Your mahallu decides how families’ information is used: the notice they see, who answers their questions, and how long records are kept.',
  'privacy.loading': 'Loading privacy settings…',
  'privacy.officer': 'Grievance officer',
  'privacy.named': 'Named',
  'privacy.notNamed': 'Not named yet',
  'privacy.officerHint': 'Families contact this person about their information. Shown on the public notice.',
  'privacy.contact': 'Contact',
  'privacy.officerName': 'Name',
  'privacy.officerPhone': 'Mobile number',
  'privacy.officerEmail': 'Email',
  'privacy.saveOfficer': 'Save officer',
  'privacy.notice': 'Privacy notice',
  'privacy.published': 'Version {{n}} published {{date}}',
  'privacy.notPublishedShort': 'Not published',
  'privacy.notPublished': 'Families must see a notice before their consent is recorded. Write it in English and Malayalam, then publish.',
  'privacy.publicLink': 'Public page',
  'privacy.newDraft': 'Write a new version',
  'privacy.draft': 'Draft of version {{n}}',
  'privacy.newVersion': 'New version',
  'privacy.template': 'Fill from template',
  'privacy.templateHint': 'A starting text with your mahallu’s name, officer and retention periods. It is your document: edit it, have counsel review it, and have a native reader check the Malayalam.',
  'privacy.bodyEn': 'Notice in English',
  'privacy.bodyMl': 'Notice in Malayalam',
  'privacy.saveDraft': 'Save draft',
  'privacy.publish': 'Publish this version',
  'privacy.publishHint': 'A published version never changes, so families can always see what they agreed to. To change the notice, publish a new version.',
  'privacy.retention': 'How long records are kept',
  'privacy.retentionHint': 'Records the mahallu must keep are fixed. Others you can lengthen, or shorten to the lowest period shown. Counsel signs this schedule off before go-live; automatic deletion starts when staging runs.',
  'privacy.record': 'Record',
  'privacy.period': 'Kept',
  'privacy.basis': 'Why',
  'privacy.months': 'Months',
  'privacy.min': 'At least {{n}} months',
  'privacy.custom': 'Your choice',
  'privacy.fixed': 'Fixed',
  'requests.title': 'Privacy requests',
  'requests.desc': 'Requests from families to erase their information. Contact details are erased; the register entry, receipts and certificates stay, and the answer says why.',
  'requests.new': 'Erasure request',
  'requests.record': 'Record request',
  'requests.newHint': 'Answer within {{days}} days. Contact details are erased; the register entry, receipts and certificates are kept.',
  'requests.section': 'Request',
  'requests.via': 'Received by',
  'requests.note': 'What they asked',
  'requests.decide': 'Decide',
  'requests.decision': 'Decision',
  'requests.person': 'Person',
  'requests.complete': 'Erase contact details',
  'requests.completeHint': 'Erases mobile number, place and work at once. The register entry, receipts and certificates stay.',
  'requests.reject': 'Refuse',
  'requests.reason': 'Reason, told to the family',
  'requests.decisionNote': 'Note',
  'requests.erasedFields': 'Erased: {{list}}',
  'requests.nothingToErase': 'Nothing was held to erase',
  'requests.show': 'Show',
  'requests.filter.open': 'Open',
  'requests.filter.closed': 'Closed',
  'requests.filter.all': 'All',
  'requests.fromHouse': 'To record a request, open the house and use the shield button on the person’s row.',
  'requests.no': 'Request',
  'requests.received': 'Received',
  'requests.due': 'Answer by',
  'requests.status': 'Status',
  'requests.outcome': 'Outcome',
  'requests.loading': 'Loading requests…',
  'requests.overdue': 'Overdue',
  'requests.none': 'No requests here.',
  'via.IN_PERSON': 'In person',
  'via.PHONE_CALL': 'Phone call',
  'via.LETTER': 'Letter',
  'via.EMAIL': 'Email',
  'via.WHATSAPP': 'WhatsApp',
  'rstatus.RECEIVED': 'Open',
  'rstatus.COMPLETED': 'Erased',
  'rstatus.REJECTED': 'Refused',
  'public.notice': 'Privacy notice',
  'public.version': 'Version {{n}} · published {{date}}',
  'public.language': 'Language',
  'public.notFound': 'This page does not exist.',
  'public.none': 'This mahallu has not published its privacy notice yet.',
  'public.officer': 'Grievance officer',
  'public.by': 'Rabita One · Mahallu Cloud by OptiFi',

  'soon.title': 'Coming in a later step',
  'soon.body': 'This screen is designed in the prototype and will be built after the member register.',

  // OptiFi platform console and mahallu links (ADR-0040).
  'console.title': 'OptiFi platform console',
  'console.scope': 'Platform scope · no member data',
  'console.section': 'OptiFi platform',
  'console.nav.overview': 'Overview',
  'console.nav.mahallus': 'Mahallus',
  'console.nav.requests': 'Demo requests',
  'console.nav.operators': 'Operators',
  'console.nav.activity': 'Console activity',
  'console.role.OWNER': 'Owner',
  'console.role.SUPPORT': 'Support',
  'console.opStatus.ACTIVE': 'Active',
  'console.opStatus.REVOKED': 'Revoked',
  'console.status.TRIAL': 'Trial',
  'console.status.LIVE': 'Live',
  'console.status.SUSPENDED': 'Suspended',
  'console.status.change': 'Change status',
  'console.status.section': 'New status',
  'console.status.reason': 'Reason',
  'console.status.reasonHint': 'Kept in the console log and in the mahallu\'s own audit log.',
  'console.status.suspendNote': 'Suspending stops every sign-in and screen for this mahallu at once. Nothing is deleted; reactivating restores access.',
  'console.lead.NEW': 'New',
  'console.lead.CONTACTED': 'Contacted',
  'console.lead.CLOSED': 'Closed',
  'console.demo': 'Demo',
  'console.noAdmin': 'No admin',
  'console.noMemberData': 'The console shows counts only. Member names, phones and amounts stay with each mahallu.',
  'console.overview.title': 'Platform overview',
  'console.overview.desc': 'Every mahallu on Rabita One, with usage counts.',
  'console.overview.mahallus': 'Mahallus',
  'console.overview.total': 'All mahallus',
  'console.overview.usage': 'Usage across mahallus',
  'console.overview.desk': 'Desk',
  'console.overview.newRequests': 'New demo requests',
  'console.col.mahallu': 'Mahallu',
  'console.col.link': 'Link',
  'console.col.status': 'Status',
  'console.col.houses': 'Houses',
  'console.col.members': 'Members',
  'console.col.receipts30d': 'Receipts (30 days)',
  'console.col.certificates': 'Certificates',
  'console.col.messages30d': 'Messages (30 days)',
  'console.col.failed30d': 'Failed messages (30 days)',
  'console.col.lastActivity': 'Last activity',
  'console.col.when': 'When',
  'console.col.person': 'Person',
  'console.col.contact': 'Contact',
  'console.col.message': 'Message',
  'console.col.role': 'Role',
  'console.col.since': 'Since',
  'console.col.action': 'Action',
  'console.col.detail': 'Detail',
  'console.mahallus.title': 'Mahallus',
  'console.mahallus.desc': 'Add a mahallu with its first admin, and suspend or reactivate one.',
  'console.mahallus.none': 'No mahallus yet.',
  'console.new.title': 'Add mahallu',
  'console.new.save': 'Create mahallu',
  'console.new.mahallu': 'Mahallu',
  'console.new.nameEn': 'Name (English)',
  'console.new.nameMl': 'Name (Malayalam)',
  'console.new.slug': 'Link name',
  'console.new.slugHint': 'The mahallu\'s own link: {{link}}. Lower-case letters, digits and hyphens; it cannot be changed later.',
  'console.new.slugBad': 'Use 2–63 lower-case letters, digits or hyphens, not a reserved word such as app or console.',
  'console.new.admin': 'First admin',
  'console.new.adminName': 'Admin name',
  'console.new.adminPhone': 'Admin mobile number',
  'console.new.adminHint': 'With country code. They sign in with a one-time code and set up an authenticator.',
  'console.requests.title': 'Demo requests',
  'console.requests.desc': 'Requests from the rabitaone.in form.',
  'console.requests.none': 'No requests yet.',
  'console.requests.retention': 'Requests are kept for 12 months to reply to them, then deleted.',
  'console.operators.title': 'Operators',
  'console.operators.desc': 'OptiFi staff who can open this console.',
  'console.operators.how': 'Operators are added or revoked only on the server with npm run console:operator, never from this screen.',
  'console.activity.title': 'Console activity',
  'console.activity.desc': 'Every console action and operator change. This log cannot be edited.',
  'console.activity.commandLine': 'Server command line',
  'console.signin.title': 'Sign in to the OptiFi console',
  'console.signin.subtitle': 'OptiFi operators only. You will need your authenticator app after the code.',
  'signin.byPhone': 'Mobile',
  'signin.byEmail': 'Email',
  'signin.phone': 'Mobile number',
  'signin.email': 'Email address',
  'signin.country': 'Country code',
  'signin.visualTitle': 'Your mahallu office, online.',
  'signin.trust1': 'Data kept in India',
  'signin.trust2': 'Two-step sign-in for the committee',
  'signin.trust3': 'Malayalam and English',
  'signin.footer': 'Protected by one-time codes and two-step sign-in · OptiFi Technologies LLP',
  'signin.visual': 'The mahallu office, online: register, varisankhya, certificates and notices in Malayalam and English.',
  'console.signin.visual': 'For OptiFi operators. Counts per mahallu only; member data stays with each mahallu.',
  'console.signin.onlyConsole': 'This account opens the OptiFi console, not a mahallu.',
  'console.signin.open': 'Open the OptiFi console',

  'common.notGiven': 'Not given',
} as const;

export type CatalogueKey = keyof typeof en;
export type Catalogue = Record<CatalogueKey, string>;
